export function Toggle({ checked, onChange, label, disabled = false, id }) {
  const inputId = id || `toggle-${label?.replace(/\s+/g, '-').toLowerCase()}`;
  return (
    <label
      htmlFor={inputId}
      className={`flex items-center justify-between gap-3 rounded-xl border border-border bg-card px-3 py-2.5 ${
        disabled ? 'opacity-60' : ''
      }`}
    >
      <span className="text-sm font-semibold text-text">{label}</span>
      <span className="relative inline-flex h-7 w-12 shrink-0 items-center">
        <input
          id={inputId}
          type="checkbox"
          role="switch"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="peer sr-only"
        />
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-border transition-colors peer-checked:bg-primary peer-focus-visible:ring-2 peer-focus-visible:ring-primary/40"
        />
        <span
          aria-hidden
          className="absolute left-0.5 h-6 w-6 rounded-full bg-card shadow transition-transform peer-checked:translate-x-5"
        />
      </span>
    </label>
  );
}
